import { useDispatch, useState, useGlobal } from "reactn";
import { useLoginWithProvider } from "state/users/hooks";
import { pathOr } from "lib/functions";
export const useLoginModalWithProvider = ({
	onClose,
	getReservation,
	blockreservation,
	openRutUpdateModal,
	handleOpenUpdateRutModal,
	handleMeet,
	setIsRutModalVisible,
	isRutRequired,
	fieldsAnswers,
}) => {
	const [error, setError] = useState(null);
	const [loadingM, setLoadingM] = useState(false);
	const [loadingG, setLoadingG] = useState(false);
	const [loadingF, setLoadingF] = useState(false);
	const [success, setSuccess] = useState(false);
	const [forms] = useGlobal("forms");
	const meta = pathOr({}, ["payload"], forms);
	const doLoginWithProvider = useDispatch("doLoginWithProvider");
	const metaTosend = {
		...meta,
		...fieldsAnswers,
	};

	const logIn = (provider) => () => {
		provider === "google" && setLoadingG(true);
		provider === "facebook" && setLoadingF(true);
		provider === "microsoft" && setLoadingM(true);
		const activeRutModal =
			handleOpenUpdateRutModal && handleOpenUpdateRutModal();

		doLoginWithProvider(provider)
			.then((state) => {
				setSuccess(true);
				provider === "google" && setLoadingG(false);
				provider === "facebook" && setLoadingF(false);
				provider === "microsoft" && setLoadingM(false);
				onClose();
				if (!state.user.phone || !state.user.rut) {
					if (isRutRequired) {
						return setIsRutModalVisible(true);
					}
				}

				if (getReservation && blockreservation)
					return getReservation(
						blockreservation,
						handleMeet(),
						metaTosend
					);

				// if (getReservation) getReservation();
			})
			.catch((err) => {
				provider === "google" && setLoadingG(false);
				provider === "facebook" && setLoadingF(false);
				provider === "microsoft" && setLoadingM(false);
				setError(errToMessage(err));
			});
	};

	return [logIn, success, loadingG, error, loadingF, loadingM];
};

const errToMessage = (err) => {
	const message =
		"Error de autentificación, por favor actualice la página o intente más tarde.";
	if (err && err.code === "auth/popup-closed-by-user")
		return {
			message:
				"Hemos detectado que cerro la ventana emergente, por favor intentelo nuevamente o actualice la página.",
			debug: err,
		};
	if (err && err.code === "auth/account-exists-with-different-credential")
		return {
			message:
				"El correo que usas para acceder a esta cuenta ya está registrado en ZeroQ",
			debug: err,
		};
	if (!err && !err.code) return { message, debug: err };

	return { message, debug: err };
};
